import React from 'react'
import { Button } from '@dasa-health/components-react'
import { ButtonContainer, Container, Illustration, Message, MessageContainer, Title } from './styles'

import Alert from 'assets/alert.svg'

export type ErrorPageProps = {
    ctaText: string
    handleClick: () => void
}

export function ErrorPage({ ctaText, handleClick }: ErrorPageProps) {
    return (
        <Container>
            <MessageContainer>
                <Illustration alt="Alerta" src={Alert} />
                <Title>Não foi possível validar sua conta pelo link</Title>
                <Message>
                    Você será redirecionado para a página de cadastro do <strong>Nav Dasa.</strong>
                </Message>
            </MessageContainer>
            <ButtonContainer>
                <Button
                    data-current-service="Entrar"
                    data-item-position="Magic Link"
                    data-item-text="Fazer cadastro no Nav Dasa"
                    onClick={handleClick}
                    variant="primary"
                >
                    {ctaText}
                </Button>
            </ButtonContainer>
        </Container>
    )
}
